import {
    MessageTemplate,
    GetAllMessageTemplatesFailureAction,
    GetAllMessageTemplatesRequestAction,
    GetAllMessageTemplatesSuccessAction,
    NormalizedMessageTemplates,
    DraftMessageTemplate,
    PostMessageTemplateRequestAction,
    PostMessageTemplateSuccessAction,
    PostMessageTemplateFailureAction,
    PatchMessageTemplateRequestAction,
    MessageTemplateId,
    DeleteMessageTemplateRequestAction,
    DeleteMessageTemplateSuccessAction,
    DeleteMessageTemplateFailureAction,
    PatchMessageTemplateSuccessAction,
    PatchMessageTemplateFailureAction,
} from './types';

export const getAllMessageTemplatesRequestAction =
    'messageTemplate/GET_ALL_MESSAGE_TEMPLATES_REQUEST';
export const getAllMessageTemplatesSuccessAction =
    'messageTemplate/GET_ALL_MESSAGE_TEMPLATES_SUCCESS';
export const getAllMessageTemplatesFailureAction =
    'messageTemplate/GET_ALL_MESSAGE_TEMPLATES_FAILURE';
export const postNewMessageTemplateRequestAction =
    'messageTemplate/POST_NEW_MESSAGE_TEMPLATE_REQUEST';
export const postNewMessageTemplateSuccessAction =
    'messageTemplate/POST_NEW_MESSAGE_TEMPLATE_SUCCESS';
export const postNewMessageTemplateFailureAction =
    'messageTemplate/POST_NEW_MESSAGE_TEMPLATE_FAILURE';
export const updateMessageTemplateRequestAction = 'messageTemplate/UPDATE_MESSAGE_TEMPLATE_REQUEST';
export const updateMessageTemplateSuccessAction = 'messageTemplate/UPDATE_MESSAGE_TEMPLATE_SUCCESS';
export const updateMessageTemplateFailureAction = 'messageTemplate/UPDATE_MESSAGE_TEMPLATE_FAILURE';
export const deleteMessageTemplateRequestAction = 'messageTemplate/DELETE_MESSAGE_TEMPLATE_REQUEST';
export const deleteMessageTemplateSuccessAction = 'messageTemplate/DELETE_MESSAGE_TEMPLATE_SUCCESS';
export const deleteMessageTemplateFailureAction = 'messageTemplate/DELETE_MESSAGE_TEMPLATE_FAILURE';

export const getAllMessageTemplatesRequest = (): GetAllMessageTemplatesRequestAction => ({
    type: 'messageTemplate/GET_ALL_MESSAGE_TEMPLATES_REQUEST',
});

export const getAllMessageTemplatesSuccess = (
    messageTemplates: NormalizedMessageTemplates,
): GetAllMessageTemplatesSuccessAction => ({
    type: 'messageTemplate/GET_ALL_MESSAGE_TEMPLATES_SUCCESS',
    messageTemplates,
});

export const getAllMessageTemplatesFailure = (
    error: string,
): GetAllMessageTemplatesFailureAction => ({
    type: 'messageTemplate/GET_ALL_MESSAGE_TEMPLATES_FAILURE',
    error,
});

export const postMessageTemplateRequest = (
    messageTemplate: DraftMessageTemplate,
): PostMessageTemplateRequestAction => ({
    type: 'messageTemplate/POST_NEW_MESSAGE_TEMPLATE_REQUEST',
    messageTemplate,
});

export const postMessageTemplateSuccess = (
    messageTemplate: NormalizedMessageTemplates,
): PostMessageTemplateSuccessAction => ({
    type: 'messageTemplate/POST_NEW_MESSAGE_TEMPLATE_SUCCESS',
    messageTemplate,
});

export const postMessageTemplateFailure = (error: string): PostMessageTemplateFailureAction => ({
    type: 'messageTemplate/POST_NEW_MESSAGE_TEMPLATE_FAILURE',
    error,
});

export const patchMessageTemplateRequest = (
    messageTemplate: MessageTemplate,
): PatchMessageTemplateRequestAction => ({
    type: 'messageTemplate/UPDATE_MESSAGE_TEMPLATE_REQUEST',
    messageTemplate,
});

export const patchMessageTemplateSuccess = (
    messageTemplate: MessageTemplate,
    id: MessageTemplateId,
): PatchMessageTemplateSuccessAction => ({
    type: 'messageTemplate/UPDATE_MESSAGE_TEMPLATE_SUCCESS',
    id,
    messageTemplate: {
        [messageTemplate.id]: messageTemplate,
    },
});

export const patchMessageTemplateFailure = (
    error: string,
    id: MessageTemplateId,
): PatchMessageTemplateFailureAction => ({
    type: 'messageTemplate/UPDATE_MESSAGE_TEMPLATE_FAILURE',
    error,
    id,
});

export const deleteMessageTemplateRequest = (
    id: MessageTemplateId,
): DeleteMessageTemplateRequestAction => ({
    type: 'messageTemplate/DELETE_MESSAGE_TEMPLATE_REQUEST',
    id,
});

export const deleteMessageTemplateSuccess = (
    id: MessageTemplateId,
): DeleteMessageTemplateSuccessAction => ({
    type: 'messageTemplate/DELETE_MESSAGE_TEMPLATE_SUCCESS',
    id,
});
export const deleteMessageTemplateFailure = (
    error: string,
): DeleteMessageTemplateFailureAction => ({
    type: 'messageTemplate/DELETE_MESSAGE_TEMPLATE_FAILURE',
    error,
});
